import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ensureFbqLoaderLoaded, isExperienceLandingRoute, isGlobalPixelExcludedRoute } from "../utils/metaPixel";

const GLOBAL_META_PIXEL_ID = "3831918606952321";

function GlobalMetaPixel() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    if (isExperienceLandingRoute(location.pathname)) return undefined;
    if (isGlobalPixelExcludedRoute(location.pathname)) return undefined;

    let cancelled = false;
    let attemptsRemaining = 20;

    const tryFire = () => {
      if (cancelled) return;
      ensureFbqLoaderLoaded();
      if (typeof window.fbq === "function") {
        window.fbq("init", GLOBAL_META_PIXEL_ID);
        window.fbq("trackSingle", GLOBAL_META_PIXEL_ID, "PageView");
        return;
      }
      attemptsRemaining -= 1;
      if (attemptsRemaining > 0) setTimeout(tryFire, 250);
    };

    tryFire();
    return () => { cancelled = true; };
  }, [location.pathname]);

  return null;
}

export default GlobalMetaPixel;